import React from 'react';
import loadable from '@loadable/component';
import { planChangeOnEnterSaga } from 'containers/PlanChange/plan-change.onenter.saga';

const PlanChange = loadable(() => import('containers/PlanChange/PlanChange'));

export default (store, client) => ({
  path: '/plan-change/:encodedId',

  onEnter: (nextState, replaceState, cb) =>
    store
      .runSagaOnce(planChangeOnEnterSaga, client, nextState, replaceState)
      .toPromise()
      .then(cb, cb),

  component: props => <PlanChange {...props} />,
});
